import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import axios from 'axios'

import BootstrapVue from 'bootstrap-vue'

import globals from './globals'
import './registerServiceWorker'

import i18n from './i18n'

import VueGeolocation from 'vue-browser-geolocation'
import Vue2Filters from 'vue2-filters'
import wysiwyg from 'vue-wysiwyg'
import VueOffline from 'vue-offline'
import VueNumerals from 'vue-numerals'
import VueClipboard from 'vue-clipboard2'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Dayjs from 'vue-dayjs';
import VueDayjs from 'vue-dayjs-plugin'
import VueHtml2pdf from 'vue-html2pdf'
import VCalendar from 'v-calendar';
import vSelect from 'vue-select'

// 1a) Day.js + relativeTime
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import isoWeek from "dayjs/plugin/isoWeek";
import 'dayjs/locale/nb' // Norwegian Bokmål - dayjs has no 'no' locale

dayjs.extend(relativeTime)

dayjs.extend(isoWeek)
dayjs.locale('nb') // use the locale you need



// Import CSS files
import 'leaflet/dist/leaflet.css'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'vue-select/dist/vue-select.css';

// Import BootstrapVue CSS files (order is important)
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(VueGeolocation),
Vue.use(Vue2Filters)
Vue.use(wysiwyg, {})
Vue.use(VueOffline)
Vue.use(VueClipboard)
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VueBootstrapTypeahead)
Vue.use(VueHtml2pdf)
Vue.use(VCalendar)
Vue.component('v-select', vSelect)
Vue.use(Dayjs, {
  filters: {
    ago: 'ago',
  },
});
Vue.use(VueDayjs)

Vue.use(VueNumerals, {
  locale: 'no'
});


// 1b) Ionicons registration
import { IonIcon } from '@ionic/vue'
Vue.component('ion-icon', IonIcon)

// give it a base URL up front:
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api'

// attach to Vue prototype so every component can do this.$http
Vue.prototype.$http = axios

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token
}

// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
